import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'rect-select-type',
  templateUrl: './rect-select-type.component.html',
})
export class RectSelectTypeComponent extends FieldType {}
